import React from 'react';
import { Link } from 'gatsby';

import PostcardStar from '../../../../images/postcards-star.png';

import '../../../styles/common/promos/friends-promo.scss';

const FriendsPromo = (props) => (
  <div className="friends-promo">
    <Link to="/support">
      <span className="headline">
        Become a Friend of the PDR
      </span>
      <img src={ PostcardStar } alt="Postcards" />
      <span className="message">
        We rely on our annual donors to keep the project alive. Perks include receiving twice-a-year our very special themed postcard packs and getting 15% off our prints.
      </span>
      <span className="action">
        Find Out More
      </span>
    </Link>
  </div>
);

export default FriendsPromo;